import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNissanComponent } from './simple-icons-nissan.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNissanComponent ],
    exports:      [ SimpleIconsNissanComponent ],
    bootstrap:    []
})
export class SimpleIconsNissanModule {}
